import type { Position2D } from '@Components/BigBrowse/Model/ModelTypes';
import { Assets } from '@Utils/AssetsStore';
import React from 'react';
import type { TextStyle, ViewStyle } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

type Props = {
  onPress: () => void;
  area: {
    topLeftCell: Position2D;
    departmentId: number;
    width: number;
    label: any;
    height: number;
  };
  scaleAspectRatio: number;
};

export function DepartmentLabel({ onPress, area, scaleAspectRatio }: Props) {
  const dynamicTextStyle: TextStyle = getDynamicStyles(scaleAspectRatio);

  const dynamic: ViewStyle = {
    top: area.topLeftCell.y * scaleAspectRatio,
    left: area.topLeftCell.x * scaleAspectRatio,
    width: area.width * scaleAspectRatio,
    height: area.height * scaleAspectRatio,
  };

  return (
    <Pressable onPress={onPress}>
      <View style={[styles.wrapper, dynamic]}>
        <Text style={[styles.label, dynamicTextStyle]}>{area.label}</Text>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
  label: {
    textAlign: 'center',
    fontSize: 14,
    fontFamily: Assets.Font_Gilroy_SemiBold,
    letterSpacing: 1.3,
    padding: '5%',
  },
});

const getDynamicStyles = (scaleAspectRatio: number): TextStyle => {
  if (scaleAspectRatio < 28) {
    return {
      fontSize: 10,
      letterSpacing: 0.3, // 10 *0.03
    };
  }

  if (scaleAspectRatio < 42) {
    return {
      fontSize: 12,
      letterSpacing: 0.36, // 12*0.03
    };
  }

  return {
    fontSize: 14,
    letterSpacing: 0.42, // 14*0.03
  };
};
